(function () {
  function clampProgress(value) {
    var n = parseFloat((value || '0').toString().replace('%', '').trim());
    if (isNaN(n)) return 0;
    if (n < 0) return 0;
    if (n > 100) return 100;
    return n;
  }

  function runAnimation(cartDrawer) {
    if (!cartDrawer) return;

    var shell = cartDrawer.querySelector('.ac-fspb-bar-shell');
    if (!shell) return;

    var fill = shell.querySelector('.ac-fspb-bar-fill-inner');
    var marker = shell.querySelector('.ac-fspb-marker');
    if (!fill || !marker) return;

    var rawProgress =
      shell.getAttribute('data-progress') ||
      shell.dataset.progress ||
      '0';

    var newProgress = clampProgress(rawProgress);

    function setPositions(progress) {
      fill.style.width = progress + '%';
      marker.style.left = progress + '%';
    }

    var prevRaw = cartDrawer.dataset.fspbProgress;

    if (prevRaw == null) {
      setPositions(newProgress);
      cartDrawer.dataset.fspbProgress = String(newProgress);
      return;
    }

    var prevProgress = clampProgress(prevRaw);

    setPositions(prevProgress);

    requestAnimationFrame(function () {
      setPositions(newProgress);
      cartDrawer.dataset.fspbProgress = String(newProgress);
    });
  }

  function observeDrawer(cartDrawer) {
    if (!cartDrawer) return;

    runAnimation(cartDrawer);

    var observer = new MutationObserver(function (mutations) {
      var shouldRun = false;

      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type !== 'childList') continue;

        m.addedNodes.forEach(function (node) {
          if (!(node instanceof HTMLElement)) return;

          if (
            (node.matches && node.matches('.ac-fspb-wrapper, .ac-fspb-bar-shell')) ||
            (node.querySelector && node.querySelector('.ac-fspb-bar-shell'))
          ) {
            shouldRun = true;
          }
        });
      }

      if (shouldRun) runAnimation(cartDrawer);
    });

    observer.observe(cartDrawer, { childList: true, subtree: true });
  }

  function initFspb() {
    var cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;
    observeDrawer(cartDrawer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFspb);
  } else {
    initFspb();
  }

  document.addEventListener('shopify:section:load', initFspb);
})();
